import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InvalidGPSAlert(props) {
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={() => { props.invalidGpsAlertClose() }}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Your GPS information is invalid"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          Mattool App identifies that you are not on a Bus; you can turn off the GPS. If you think the App made a mistake, please ignore it.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.invalidGpsAlertClose()}>Ignore</Button>
          <Button onClick={() => {
            props.toggleGPS(false)
            props.invalidGpsAlertClose()
          }}>Turn Off GPS</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
